import React, { useState, useEffect } from 'react';
import './dynamicPackage.less';
import DynamicPage from './DynamicPage';
import { DynamicPageType } from '../../interfaces';

type DynamicPageEditProps = {
  isPreviewMode: any;
  selectedInstance: any;
  setSelectedInstance: any;
  type?: DynamicPageType;
  isEdit?: boolean;
};

export default function DynamicPageEdit({
  isPreviewMode,
  selectedInstance,
  setSelectedInstance,
  type,
  isEdit = false,
}: DynamicPageEditProps) {
  return (
    <DynamicPage
      isEdit={isEdit}
      isPreviewMode={isPreviewMode}
      selectedInstance={selectedInstance}
      setSelectedInstance={setSelectedInstance}
      type={type}
    />
  );
}
